import type { TFunction } from 'i18next'
import type { BodyMapNodeId } from './calibration/onboardingConstants'

export const WEEKDAY_KEYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const

export function weekdayLabels(t: TFunction): string[] {
  return WEEKDAY_KEYS.map((key) => t(`onboarding.weekdays.${key}`))
}

export function weekdayLabel(t: TFunction, dayKey: string): string {
  const normalized = dayKey.toLowerCase()
  return t(`onboarding.weekdays.${normalized}`, { defaultValue: dayKey })
}

export type HealthScreeningQuestion = {
  id: string
  question: string
  exclusion_message: string
}

export const HEALTH_SCREENING_IDS = [
  'cardiovascular',
  'recent_surgery',
  'pregnancy',
  'eating_disorder',
  'medical_supervision',
] as const

export function healthScreeningQuestions(t: TFunction): HealthScreeningQuestion[] {
  return HEALTH_SCREENING_IDS.map((id) => ({
    id,
    question: t(`onboarding.healthScreening.questions.${id}.question`),
    exclusion_message: t(`onboarding.healthScreening.questions.${id}.exclusion`),
  }))
}

export function bodyMapNodeLabel(t: TFunction, nodeId: BodyMapNodeId): string {
  return t(`onboarding.calibration.nodes.${nodeId}`)
}

export function symptomPresets(t: TFunction, nodeId: BodyMapNodeId): string[] {
  const raw = t(`onboarding.calibration.symptoms.${nodeId}`, { returnObjects: true })
  return Array.isArray(raw) ? raw.map(String) : []
}
